import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { ActivityFeedMessageRow } from '../components/ActivityFeedMessageRow';
import { CommunicationSearchFilters } from '../../models/messages/communications-search-filters';
import { MessageDocument } from '../../models/messages/message-document';
import { MessageRead } from '../../models/messages/message-read';
import { CommunicationSvc } from '../../../../communications/service';
import '../../../../communications/styles.scss';

export const ActivityFeedScene = () => {

    const dispatch = useDispatch();
    const [service] = React.useState(new CommunicationSvc());
    const [filterParams, setFilterParams] = React.useState(new CommunicationSearchFilters());

    const [messages, setMessages] = React.useState(() => {
         const initial = new PagedApiResult<MessageRead>();
         initial.pagination = filterParams.paginationInfo;
         initial.pagination.reusePaging = true;
         return initial;
    });

    const downloadPdf = async (id: number) => {
        const req = new MessageDocument(id);
        dispatch(getDocumentHelper(req));
    };

    const resendMessage = async (id : number) => {
        const result = await service.resendCommunication(id);
        if (result.status === StatusCode.Success) {
            await onSearch(filterParams);
        }
    };

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: CommunicationSearchFilters) => {
        const response = await service.search(MessageRead, filters);
        if (response.status === StatusCode.Success) {
            setMessages(response.data);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new CommunicationSearchFilters();
        setFilterParams(tmp);
    };
    
    return <PageContent pageName={PageNames.COMMUNICATIONS_ACTIVITY_FEED}>
            <PageBody>
                <PagedList
                    noResultsMessage="No messages found, please search again."
                    searchCallback={ onSearch }
                    data={ messages }
                    filterProps={ filterParams }
                    selectableClass=""
                    onFilterUpdate={ onParamsUpdate }
                    onReset={ onParamsReset }
                    rowRenderer={(itm: MessageRead) => 
                        <ActivityFeedMessageRow
                            key={itm.id}
                            downloadAction={ downloadPdf }
                            resendAction={ resendMessage }
                            message={itm}
                        />                    
                    }
                />                   
            </PageBody>
        </PageContent>;
};
